module.exports = __webpack_public_path__ + "img/board.8ef69a8a.png";